import { useQuery } from '@tanstack/react-query';
import { useRouter } from 'next/router';

import { useAppDispatch } from 'store';

import { $api } from '../../global';
import { IBlokTest } from '../models';
import { blokTestConst, startTimer } from '..';

export const useStartedTest = (type?: string) => {
  const { push } = useRouter();
  const dispatch = useAppDispatch()

  const { data: startedTest, ...args } = useQuery<IBlokTest>({
    queryKey: [blokTestConst.queryKeys.ALL_STARTED_TEST, type],
    queryFn: async () => {
      const { data } = await $api.get('/progress', { params: { type } });

      return data;
    },
    onSuccess: (data) => {
      if (!data) {
        push(`/${type}`);
      }
      dispatch(startTimer())
    },
    onError: (error: any) => {
      if (error?.response?.status === 400) {
        push(`/${type}`);
      }
    }
  });

  return { startedTest, ...args };
};
